import {
  CataloguePayloadModel,
  CurrentCatalogueErrorsModel,
  CurrentStoreListingErrorModel,
  StoreListingPayloadModel,
} from 'src/models';

class InitialState {
  constructor() {
    this.uiState = new UIState();

    this.subjectManageState = new SubjectManageState();
    this.subjectReview = new SubjectReviewState();
    this.publisherState = new PublisherStateModel();
  }
}

/* *****************************  [NAVIGATION MANAGER]  ************************** */

export class NavigationManagerStateModel {
  constructor() {
    this.navigationTree = [];
    this.savedNavigationMenu = [];
  }
}

/* *****************************  [TRANSCODING MANAGER]  ************************** */

export class TranscodingManagerStoreModel {
  constructor() {
    this.tobeTranscodedJobs = [];
    this.toBeReTranscodedJobs = [];
    this.cancelledJobs = [];
    this.erroredJobs = [];
    this.submittedJobs = [];
    this.runningJobs = [];
    this.finishedJobs = [];
    this.isTranscodingSuccess = false;
  }
}

/* *****************************  [PUBLISHER]  ************************** */

export class PublisherStateModel {
  constructor() {
    this.catalogueManager = new CatalogueManagerStateModel();
    this.storeManager = new StoreManagerStateModel();
    this.otsManager = new OtsManagerStateModel();
  }
}

export class CatalogueManagerStateModel {
  constructor() {
    this.catalogueList = []; // List of catalogue and storeListing
    this.batches = [];
    this.batchesPagination = { list: [], totalDataCount: 0 }; // search results for the Pick Batch dropdown
    this.curentCatalogueSubjectList = [];
    this.catalogueSubjectList = [];

    // catalogue details from backend
    this.currentCatalogueInfo = '';
    // this is the payload send to the backend on save
    this.currentCatalogueInfoPayload = new CataloguePayloadModel();
    // This is used to display error in step indicator
    this.currentCatalogueErrors = new CurrentCatalogueErrorsModel();
    this.isSubmit = false;
  }
}

export class StoreManagerStateModel {
  constructor() {
    this.categoryList = []; // list of caegory and subcategory
    this.storeList = []; // list of store listing
    this.selectedStoreList = []; // list of selected store listing in selected subcategory
    this.selectedCategory = {}; // selected category in the category page
    this.selectedSubCategory = {}; // selected sub category in the category page
    this.selectedCategoryIndex = '';
    this.selectedSubCategoryIndex = '';

    // catalogue details from backend
    this.currentStoreListing = '';
    // this is the payload send to the backend on save
    this.currentStoreListingPayload = new StoreListingPayloadModel();
    // This is used to display error in step indicator
    this.currentStoreStepsError = new CurrentStoreListingErrorModel();
    this.isSubmit = false;
    this.featuresList = [];
  }
}

export class OtsManagerStateModel {
  constructor() {
    this.otsCatalogueList = [];
    this.subscriptionsList = [];
    this.backupSubscriptionList = [];
  }
}

/* ********************************************************************** */

class SubjectManageState {
  constructor() {
    this.subjects = [];
    this.finishedSubjects = [];
    this.subjectTypeList = {};
    this.users = [];
    this.currentSubjectId = '';
    this.currentUnitId = '';
    this.subjectsWithUnits = [];
    this.subjectsUnitPayload = [];
    this.unitsTopicPaylaod = [];
    this.subjectsVideos = [];
    this.subjectVideoUrls = [];
    this.assignees = [];

    this.lastApiTimeStamp = ''; // Since, i am caching the api response, i need to know when to refresh.
  }
}

class CouponManagementState {
  constructor() {
    this.coupons = {
      content: [],
      totalElements: 0,
      totalPages: 1,
      size: 10,
    };
    this.catalogues = [];
  }
}

class SubjectReviewState {
  constructor() {
    this.finishedSubjects = [];
  }
}

class UserManagementState {
  constructor() {
    this.users = [];
    this.roles = [];
    this.courses = [];
  }
}

class LoginManagementState {
  constructor() {
    this.isOTPcreated = false;
    this.loginSuccess = false;
  }
}

class UISuccessState {
  constructor() {
    this.isSuccess = false;
    this.showBanner = false;
    this.message = '';
    this.bannerAutoHideDuration = 6000;
    this.response = '';
    this.title = '';
    this.isAuthTokenValid = true;
  }
}

class UIErrorState {
  constructor() {
    this.hasError = false;
    this.showBanner = false;
    this.message = '';
    this.bannerAutoHideDuration = 6000;
    this.response = '';
    this.title = '';
    this.isAuthTokenValid = true;
  }
}

class UIState {
  constructor() {
    this.error = new UIErrorState();
    this.success = new UISuccessState();
    this.currentState = ''; // map this to "error/success" to dynamically access the curent state
    this.showSpinner = false;
    this.apiInProgress = false;
    this.showSuccessBanner = false;
    this.uiRouteState = [];
  }
}

class FileExplorerState {
  constructor() {
    this.files = [];
    this.currentState = {
      isSubjectsFolder: true,
      viewType: 'Subjects',
      subject: '',
      subjectId: '',
      unit: '',
      unitId: '',
      topic: '',
      topicId: '',
    };
    this.rawEachSubject = {};
    this.currentList = [];
    this.allSubjects = [];
    this.liveClassRecordings = [];
  }
}

class LegalPageState {
  constructor() {
    this.allTncList = [];
  }
}

class DeliveryState {
  constructor() {
    this.paginatedResponse = {
      content: [],
      totalElements: 0,
      totalPages: 1,
      size: 10,
    };
    this.bulkAssignResult = null;
    this.courseOptions = [];
  }
}

class StudentUpdatesState {
  constructor() {
    this.updates = [];
  }
}

class StudentDetailsState {
  constructor() {
    this.studentsList = [];
    this.studentsTotalElements = 0;
    this.studentDetails = {};
    this.subscriptionsList = [];
    this.invoicesList = [];
    this.emailverified = false;
    this.addonsList = [];
  }
}

class LiveClassData {
  constructor() {
    this.liveClasses = [];
    this.subjects = [];
    this.chapters = [];
    this.teachers = [];
    this.batches = [];
    this.newChapter = {};
    this.newSubject = {};
    this.zoomAccounts = [];
    this.occupiedZoomAccounts = [];
    this.teacherList = [];
  }
}
class BatchDetailsState {
  constructor() {
    this.batchList = [];
    this.batchListTotalCount = 0;
    this.studentsList = [];
    this.branchList = [];
    this.programList = [];
    this.createUpdateOrCloseBatchSuccess = false;
    this.createGroupSuccess = false;
    this.uploadStudentsSuccess = false;
    this.batchDetails = {};
    this.groupList = [];
    this.groupListTotalCount = 0;
    this.centerCodes = [];
    this.classRoomProgressDetailsList = [];
  }
}
class FinanceDetailsState {
  constructor() {
    this.paymentsList = [];
  }
}

class AttendanceDetailsState {
  constructor() {
    this.classroomAttendanceData = [];
    this.studentsAttendanceData = [];
    this.studentsDetails = {};
  }
}

class DeviceResetState {
  constructor() {
    this.requests = [];
    this.authValidated = false;
  }
}
class CampaignManagementState {
  constructor() {
    this.campaigns = [];
    this.campaignDetails = {};
    this.categoryTree = [];
    this.categoryTreeLoading = false;
  }
}

class ScholarshipTypeState {
  constructor() {
    this.types = [];
    this.documents = [];
  }
}
export {
  InitialState,
  SubjectManageState,
  SubjectReviewState,
  UserManagementState,
  LoginManagementState,
  UIErrorState,
  UISuccessState,
  UIState,
  FileExplorerState,
  CouponManagementState,
  LegalPageState,
  DeliveryState,
  StudentUpdatesState,
  StudentDetailsState,
  LiveClassData,
  BatchDetailsState,
  FinanceDetailsState,
  AttendanceDetailsState,
  DeviceResetState,
  CampaignManagementState,
  ScholarshipTypeState,
};
